import { render, staticRenderFns } from "./bonusDialog.vue?vue&type=template&id=2feed867&scoped=true&"
import script from "./bonusDialog.vue?vue&type=script&lang=js&"
export * from "./bonusDialog.vue?vue&type=script&lang=js&"
import style0 from "./bonusDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bonusDialog.vue?vue&type=style&index=1&id=2feed867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feed867",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VImg,VRow})
